import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { StockBasicInfoResponse } from '../../../response/responseSchema';
import Box from '@client/uikit/Box';
import Frame from '@client/uikit/Frame';
import { apiClient } from '@app/apiClient';
import { useMobxInstance } from '@client/clientUtils/mobxUtil';
import StockModalBasicInfo from './StockModalBasicInfo';
import StockPriceInfo from './StockModalPriceInfo';
import TvSymbolOverview from './tvWidget/TvSymbolOverview';
import TvTechnicalAnalysis from './tvWidget/TvTechnicalAnalysis';
import TvFundamental from './tvWidget/TvFundamental';

class ViewStore {
    readonly ticker: string;
    stockBasicInfo: StockBasicInfoResponse | null = null;
    isLoading: boolean = true;
    error: string | null = null;

    constructor(ticker: string) {
        this.ticker = ticker;
        makeAutoObservable(this);
    }

    async fetch() {
        this.isLoading = true;
        this.error = null;

        try {
            const stockBasicInfo = await apiClient.stock.public.getStockBasicInfo.$query({
                ticker: this.ticker,
            });

            runInAction(() => {
                this.stockBasicInfo = stockBasicInfo;
                this.isLoading = false;
            });
        } catch (error) {
            console.error('Failed to fetch stock basic info:', error);
            runInAction(() => {
                this.error = 'Failed to fetch stock basic info';
                this.isLoading = false;
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }
}

const NewsDetailPage = observer(() => {
    const { ticker } = useParams();
    const viewStore = useMobxInstance(ViewStore, ticker as string);

    useEffect(() => {
        viewStore.fetch();
    }, [viewStore]);

    return (
        <Frame className="pt-0">
            <Frame.Title
                title={viewStore.stockBasicInfo?.nameKo || viewStore.stockBasicInfo?.name}
                isShowOnlyHeader={true}
            />
            <Box className="px-0">
                <TvSymbolOverview ticker={viewStore.ticker} />
            </Box>
            <Box isLoading={viewStore.isLoading} className="flex flex-col gap-3">
                <StockModalBasicInfo ticker={viewStore.ticker} />
            </Box>
            <Box>
                <Box.Title title="수익률" />
                <StockPriceInfo ticker={viewStore.ticker} />
            </Box>
            <Box>
                <TvTechnicalAnalysis ticker={viewStore.ticker} />
            </Box>
            <Box className="pt-2 pb-0">
                <TvFundamental ticker={viewStore.ticker} />
            </Box>
        </Frame>
    );
});

export default NewsDetailPage;
